/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_appsync_graphqlEndpoint": "https://ersz3pymnbgrjljqcqaqfyw3ve.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ttmncbi5mrd5vn3emf63vgjia4",
    "aws_cognito_identity_pool_id": "eu-north-1:da6bafbd-07c9-4121-b23b-2a5013bd527b",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_ceYrDUylB",
    "aws_user_pools_web_client_id": "7j4p6ph1220igctbf3tf0topt6",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
